import React, {  } from 'react';
import styles from '../Wyszukiwarka.module.css';
import { useZamowienia } from 'hooks/useZamowienia';


  export default function WysokoscPapieru({arkusz_wysokosc, setArkusz_wysokosc} ){
        const { globalSearch } = useZamowienia();
        const handleSubmit = (event) => {
        event.preventDefault(); // Blokuje przeładowanie strony po wciśnięciu Enter
        globalSearch();
      };

  return(
      <form onSubmit={handleSubmit} className={styles.colData_nr}>

      <label className={styles.labelData}> Papier wys. </label>
      <input className={styles.inputData} style={{width:"95px"}} type="text"
            value={arkusz_wysokosc}
            onChange={(event) => {
              const re = /^[0-9]+$/;
              if (event.target.value === '' || re.test(event.target.value)) {
              setArkusz_wysokosc(event.target.value);
              }
            }}></input>
    </form>
  );
}